import { jsx as _jsx } from "react/jsx-runtime";
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';
import { cn } from './utils.js';
const Separator = React.forwardRef(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (_jsx(SeparatorPrimitive.Root, { ref: ref, decorative: decorative, orientation: orientation, className: cn('shrink-0 border-0 bg-transparent', orientation === 'horizontal'
        ? 'h-0 w-full border-t border-border'
        : 'h-full w-0 border-l border-border', className), ...props })));
Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };
